export const func = (id, msg) => {
  // console.log(id, msg)
};
export const func1 = (id, msg) => {
  // console.log(id, msg)
};